<template>
    <div class="form-group row agent d-flex align-items-end mb-3">
        <div class="col-sm-4">
            <label>Commission to:</label>
            
            <v-select 
                v-model="selectedAgent" 
                :options="getAgents"
                placeholder="- Select person -" 
                :searchable="false"
                label="name" 
                @input="updateAgent">
            </v-select>
        </div>

        <!-- Not in use for now. dealType will default to null

        <div class="col-sm-8">
            <div class="d-flex align-items-center justify-content-end">
                <div class="p-2" v-for="dealType in dealTypes">
                    <label class="ml-3">
                        <radio name="deal-type" :checked="(dealType.id === selectedDealType.id)" :value="dealType.id + ''" @input="changeDealType">
                            {{ dealType.description }}
                        </radio>
                    </label>
                </div>
            </div>
        </div>
        
        -->
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function () {
            return {
                form: {},
                selectedAgent: null,
                selectedDealType: null,
            }
        },
        created: function() {
            this.init();
            this.form = JSON.parse(JSON.stringify(this.getClonedReservation));
        },
        asyncComputed: {
            async dealTypes() {
                try {
                    let response = await axios.get('api/settings/GetBookingMethodTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.dealType && !isNaN(this.form.dealType)) {
                            this.selectedDealType = response.data.find(item => item.id === this.form.dealType);
                        }
                        else {
                            this.selectedDealType = response.data[0];
                            this.form.dealType = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getAgents',
                'account',
            ]),
        },
        methods: {
            ...mapActions([
                'initAgents',
                'updateClonedReservation',
            ]),
            async init() {
                this.initAgents().then(() => {
                    // Edit

                    if (this.form.agent && this.form.agent.id !== undefined && !isNaN(this.form.agent.id)) {
                        let found = this.getAgents.find(a => a.id === this.form.agent.id);

                        if (found) {
                            this.selectedAgent = found;
                            return;
                        }
                    }

                    // Default to first agent if none was set (not editing)

                    this.selectedAgent = this.getAgents[0];
                });
            },
            changeDealType(dealType) {
                this.form.dealType = parseInt(dealType);
                this.selectedDealType = this.dealTypes.find(d => d.id === parseInt(dealType));

                this.$emit('updateFields', { dealType: this.form.dealType });
            },
            updateAgent: function() {
                // Sending full object as per API specifications instead of just ID

                this.$emit('updateFields', { agent: 
                    {
                        id: this.selectedAgent.id,
                        name: this.selectedAgent.name
                    }
                });
            },
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>




// WEBPACK FOOTER //
// Agent.vue?5be23f5a